<template>
  <i
    v-if="!$slots.default"
    v-b-tooltip="tooltipConfig"
    :class="['fa cursor-help', iconClass]"
    :title="value"
  />
  <span v-else v-b-tooltip="tooltipConfig" class="cursor-help" :title="value">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },

    iconClass: {
      type: String,
      default: "fa-info-circle",
    },

    bottom: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: null,
    },
  },

  computed: {
    tooltipConfig() {
      return {
        hover: true,
        // if placement provided, use it, else fall back to previous behavior
        placement: this.placement ? this.placement : this.bottom ? "bottom" : "top",
        container: "body",
      };
    },
  },
};
</script>
